import { range } from "../Number.js";
function trim(input) {
  return input.trim().replace(/[ \t]+/g, " ");
}
function isNonEmpty(input) {
  return typeof input === "string" && input.trim().length > 0;
}
const ILLEGAL_SPACE_CHAR_CODES = [
  ...range(0, 9),
  11,
  12,
  ...range(14, 27),
  ...range(128, 159),
  9223,
  9086,
  512,
  8206,
  8207
];
const ILLEGAL_SPACE_REGEXP = new RegExp(`[${ILLEGAL_SPACE_CHAR_CODES.map((c) => `\\u${c.toString(16).padStart(4, "0")}`).join("")}]`, "g");
function includeIllegalSpaceChars(v) {
  return ILLEGAL_SPACE_REGEXP.test(v);
}
function replaceIllegalSpaceChars(src, dst = " ") {
  return src.replace(ILLEGAL_SPACE_REGEXP, dst);
}
export {
  ILLEGAL_SPACE_REGEXP,
  includeIllegalSpaceChars,
  isNonEmpty,
  replaceIllegalSpaceChars,
  trim
};
//# sourceMappingURL=Space.js.map
